import { tv } from 'tailwind-variants'

type Props = {
  padding?: 's' | 'm'
  children: React.ReactNode
}

const card = tv({
  base: 'bg-white rounded-2xl w-full shadow-[0px_8px_16px_0px_rgba(197,197,197,0.05)] flex flex-col gap-2',
  variants: {
    padding: {
      s: 'p-4',
      m: 'p-6',
    },
  },
  defaultVariants: {
    padding: 's',
  },
})

export const Panel: React.FC<Props> = ({ padding, children }) => {
  const className = card({ padding })

  return <div className={className}>{children}</div>
}
